import { render, staticRenderFns } from "./EditSupplierRoomNameDialog.vue?vue&type=template&id=6c4bf228"
import script from "./EditSupplierRoomNameDialog.vue?vue&type=script&lang=js"
export * from "./EditSupplierRoomNameDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports